import {useContext, useEffect} from 'react';

import {useDispatch} from 'react-redux';

import HostContext from 'HostContext';
import {getDomainLogo, getDomainLogoExt} from 'Store/LogoStore';

/**
 * Domain logo fetch hook to use in booking context (not landing page)
 * @param {string} calendarId
 */
export function useDomainLogoFetcher(calendarId) {
  const hostValue = useContext(HostContext);
  const dispatch = useDispatch();

  const isHost = hostValue?.isHost;

  useEffect(() => {
    if (!isHost && calendarId) {
      dispatch(getDomainLogoExt(calendarId));
    } else if (isHost) {
      dispatch(getDomainLogo());
    }
  }, [dispatch, isHost, calendarId]);
};
